import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollService {
  private positions = new Map<string, number>();

  setPosition(url: string, pos: number) {
    this.positions.set(url, pos);
  }

  getPosition(url: string): number | undefined {
    return this.positions.get(url);
  }
}